const msgs = {
  'not-enough-data': 'Not enough data',
  'unknown-error': 'Unknown error',
  'not-permissions': "You don't have enough permissions for this action",

  'login-field-empty':  'Please enter your login!',
  'login-field-no-email': 'Your login should be an email!',
  'password-field-empty': 'Please enter your password!',
  'password-field-too-short': 'Your password is too short!',
  'token-empty': 'You looks like a robot!',
  'empty-recaptcha': 'Faild to generate ReCaptcha',
  
  'signin-failed': 'Signing in failed',
  'signin-wrong-data': 'Invalid username or password',

  'load-orders-filed': 'Failed to load orders',
  'empty-order-id': 'Empty order Id',
  'empty-message': 'Empty message',  

  'user-search': 'Faild to search an user', 
  'user-list': 'Faild to load a user list', 
  'user-details': 'Faild to load user details', 
  'user-email-unsuitable': 'Wrong email format',
  'user-no-email': 'Please enter client email',
  'user-short-password': 'Password is too short',
  'user-create-failed': 'Failed to create the user',
  'user-password-no-match': 'Passwords don\'t match',
  'user-delete-failed': 'Failed to delete the user',
  'user-edit-failed': 'Failed to edit the user',
  'user-main-updated': 'Failed to uptade the user information',
  'user-pass-updated': 'Failed to uptade the user passwords',
  'user-updated-himself': 'Your information hasn\'t been updated',
  'user-no-current-password': 'Your have to enter current password',
  'user-deleted':       'User was deleted successfully',
  'user-create':        'User was added!',
  'user-edited':        'User was edited!',
  'user-no-roles':      'User should have at least one role!',
  'not-permissions-to-assignable': "You don't have enough permissions for edit assignable",  

  'role-no-id':         'Please enter role ID!',
  'role-add-failed':    'Failed to add new role!',
  'role-delete-failed': 'Failed to delete role!',
  'role-edit-failed':   'Failed to edit role!',
  'role-added':         'Role {{id}} has been added successfully!',
  'role-edited':        'Role {{id}} has been updated successfully!',
  'role-deleted':       'Role {{id}} has been deleted successfully!',
  'role-id-too-short':  'Role ID should have more then {{len}} length!',

  'vendor-list':          'Faild to load a vendor list',
  'vendor-no-name':       'Please enter vendor name',
  'vendor-create':        'Vendor was added!',
  'vendor-create-failed': 'Failed to create the vendor',
  'vendor-edited':        'Vendor was edited!',
  'vendor-edit-failed':   'Failed to edit the vendor',
  'vendor-deleted':       'Vendor was deleted successfully',
  'vendor-delete-failed': 'Failed to delete the vendor',
};

export const msg = (key: keyof typeof msgs, options?: Record<string, string | number>): string => 
  options
    ? Object.entries(options).reduce((acc, [key, value]) =>
      acc.replaceAll(`{{${key}}}`, String(value)), msgs[key])
    : msgs[key]; 
